const AVA = ['#234F37', '#1B3D2A', '#2E6243', '#3A5A46', '#27543A'];

/** Deterministic avatar background from a name. */
export function avatarColor(name: string): string {
  let h = 0;
  for (let i = 0; i < name.length; i++) {
    h = (h * 31 + name.charCodeAt(i)) % AVA.length;
  }
  return AVA[h];
}

export function initials(first: string, last: string): string {
  return `${(first[0] ?? '').toUpperCase()}${(last[0] ?? '').toUpperCase()}` || '–';
}

export const money = (n: number): string =>
  n >= 1000 ? `$${(n / 1000).toFixed(n % 1000 === 0 ? 0 : 1)}k` : `$${n}`;

export const moneyFull = (n: number): string => `$${n.toLocaleString()}`;
